// @ts-nocheck
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';

export const getEmailTemplate = (body, loader = true) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.EMAIL_TEMPLATE.GET_ALL_EMAIL_TEMPLATES}`,
      { params: body, loader }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
export default function useEmailTemplate() {
  const createEmailTemplate = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.EMAIL_TEMPLATE.CREATE_EMAIL_TEMPLATE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getSingleEmailTemplate = (params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.EMAIL_TEMPLATE.UPDATE_EMAIL_TEMPLATE}`,
        { params, loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateEmailTemplate = (body, params) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.EMAIL_TEMPLATE.UPDATE_EMAIL_TEMPLATE}`,
        body,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const removeEmailTemplate = (params) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.EMAIL_TEMPLATE.UPDATE_EMAIL_TEMPLATE}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getEmailTemplateTags = (params, loader = true) =>
    axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.EMAIL_TEMPLATE.GET_EMAIL_TEMPLATE_TAGS}`,
      { params, loader }
    );

  return {
    getEmailTemplate,
    updateEmailTemplate,
    createEmailTemplate,
    removeEmailTemplate,
    getEmailTemplateTags,
    getSingleEmailTemplate,
  };
}
